import {Regiao} from './regiao';
import {Construtor} from './construtor';

export class RegiaoCliente implements Construtor<RegiaoCliente> {

  public idRegiaoCliente: number;
  public idCliente: number;
  public regiao: Regiao;
  public selecionado: boolean;
  public alterado: boolean;

  constructor(object?: any) {
    this.regiao = new Regiao();
    if (object !== undefined) {
      if (object instanceof RegiaoCliente) {
        this.copyObject(object);
      } else if (object instanceof Regiao) {
        this.regiao = new Regiao(object);
      } else {
        this.parseFromJson(object);
      }
      if (!this.modeloCompleto()) {
        return null;
      }
    }
    return this;
  }

  get obterIdRegiaoCliente(): number {
    return this.idRegiaoCliente;
  }

  set IdRegiaoCliente(idRegiaoCliente: any) {
    this.idRegiaoCliente = idRegiaoCliente;
  }

  get obterIdCliente(): number {
    return this.idCliente;
  }

  set IdCliente(idCliente: any) {
    this.idCliente = idCliente;
  }

  get obterRegiao(): Regiao {
    return this.regiao;
  }

  set Regiao(regiao: any) {
    this.regiao = new Regiao(regiao);
  }

  copyObject(regiaoCliente: RegiaoCliente): void {
    this.idRegiaoCliente = regiaoCliente.obterIdRegiaoCliente;
    this.idCliente = regiaoCliente.obterIdCliente;
    this.regiao = regiaoCliente.regiao;
  }

  parseFromJson(regiaoCliente: any): void {
    this.IdRegiaoCliente = regiaoCliente.idRegiaoCliente;
    this.IdCliente = regiaoCliente.idCliente;
    this.regiao = regiaoCliente.regiao;
  }

  modeloCompleto(): boolean {
    return this.idRegiaoCliente !== undefined;
  }

  getNewInstance(object?: any): RegiaoCliente {
    return new RegiaoCliente(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/regiao-cliente.ts